module.exports = __webpack_public_path__ + "29806f1a2be3f1988ce07f15f06ddb03.ttf";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Italic.ttf
// module id = 352
// module chunks = 0